import { useSetWorkspaceFilter, useWorkspaceFilter } from '@gripp/shared-logic';
import {
  countFilters,
  FilterHeaders,
  SlideAction,
  useSlideLayout,
  ViewMode,
  WorkspacesSearchInput,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';

export const WorkspacesFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: workspaceFilter } = useWorkspaceFilter();
  const { mutateAsync: setWorkspaceFilter } = useSetWorkspaceFilter();
  const filterCount = countFilters(workspaceFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/workspaces/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={workspaceFilter?.keyword}
        searchComponent={<WorkspacesSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() => setWorkspaceFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
});
